var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThickIcnNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_2307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 71C55.1061 71 71 55.1061 71 35.5C71 15.8939 55.1061 0 35.5 0C15.8939 0 0 15.8939 0 35.5C0 55.1061 15.8939 71 35.5 71Z",
    fill: "#3986E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 50.9307L44.4296 69C59.6935 65.0092 71 51.3741 71 35.0785C71 34.746 71 34.4134 71 34.0808L56.5276 21L26 50.9307Z",
    fill: "#0B59B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8079 43.6565C38.3974 45.2391 38.3974 47.9522 36.8079 49.5348L33.5153 52.813C31.9258 54.3956 29.2009 54.3956 27.6114 52.813L13.1921 38.3435C11.6026 36.7609 11.6026 34.0478 13.1921 32.4652L16.4847 29.187C18.0742 27.6043 20.7991 27.6043 22.3886 29.187L36.8079 43.6565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7702 19.1776C50.3354 17.6075 53.0186 17.6075 54.5838 19.1776L57.8261 22.4299C59.3913 24 59.3913 26.6916 57.8261 28.2617L33.2298 52.8224C31.6646 54.3925 28.9814 54.3925 27.4161 52.8224L24.1739 49.5701C22.6087 48 22.6087 45.3084 24.1739 43.7383L48.7702 19.1776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_2307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickIcnNew);
export default __webpack_public_path__ + "static/media/thick-icn-new.c1adab84b3a394b524142934f3308016.svg";
export { ForwardRef as ReactComponent };